import find from "lodash/find";
import { FiltersV2EventHandlers, FilterV2Event, useFiltersV2EventsBus } from "PFApp/components/filters_v2";
import { FilterKeyV2Optional, FiltersMetaV2, FilterV2 } from "PFTypes/filters_v2";
import { useEffect } from "react";

export const useOnFilterUpdate = (
  filterKeyOrPredicate: FilterKeyV2Optional | ((filter: FilterV2) => boolean),
  action: (filter: FilterV2, previousFilter: FilterV2 | null, updatedState: FiltersMetaV2) => void
) => {
  const eventsBus = useFiltersV2EventsBus();

  useEffect(() => {
    const handleFiltersUpdate: FiltersV2EventHandlers[FilterV2Event.FiltersUpdate] = ({
      previousFilters,
      updatedFilters,
      updatedState
    }) => {
      const predicate =
        typeof filterKeyOrPredicate === "function" ? filterKeyOrPredicate : { name: filterKeyOrPredicate };
      const updatedFilter = find(updatedFilters, predicate) as FilterV2 | undefined;

      const previousFilter = find(previousFilters, predicate) as FilterV2 | null;

      if (updatedFilter) {
        action(updatedFilter, previousFilter, updatedState);
      }
    };

    eventsBus.on(FilterV2Event.FiltersUpdate, handleFiltersUpdate);
    return () => {
      eventsBus.removeListener(FilterV2Event.FiltersUpdate, handleFiltersUpdate);
    };
  }, [eventsBus, action, filterKeyOrPredicate]);
};
